import React from 'react'
import CustomInput from '../shared/Input/CustomInput'
import { Patterns } from '../../models/common'
interface ProjectMemberProps {
    register: any
    visible?: boolean
    index: number
    errors?: any
}

function ProjectAdvisor({ 
    register, 
    index, 
    visible=false,
    errors = null,
}: ProjectMemberProps) {
    
    return (
        <div className='ProjectAdvisorContainer'>
            <label>Asesor {index+1} de Proyecto</label>
            <div className='ProjectAdvisor'>
                <CustomInput capitalize='uppercase' label="Nombre Completo" field={'projectAdvisors.'+index+'.name'} register={register} rules={{required:true, maxLength: 150 }} visible={visible} errors={errors}/>
                <CustomInput capitalize='none' label="Correo Electrónico" field={'projectAdvisors.'+index+'.email'}  register={register} rules={{required:true, maxLength: 150, pattern:Patterns.email }} visible={visible} errors={errors}/>
            </div>
        </div>
    )
}

export default ProjectAdvisor